import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/mac/development/web_projects/codigo/wisly/src/app/learn/components/LearnBenefitsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/mac/development/web_projects/codigo/wisly/src/app/learn/components/LearnCategoriesSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/mac/development/web_projects/codigo/wisly/src/app/learn/components/LearnCTASection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/mac/development/web_projects/codigo/wisly/src/app/learn/components/LearnHeroSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/mac/development/web_projects/codigo/wisly/src/app/learn/components/LearnHowItWorksSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/mac/development/web_projects/codigo/wisly/src/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/mac/development/web_projects/codigo/wisly/src/components/Header.tsx");
